<mat-sidenav-container *ngIf="!loading && absenceInfo" class="sidenav-container">
  <mat-sidenav-content>
    <mat-toolbar>
      <span>Conductor: {{ absenceInfo.driverName }}</span>
      <span class="spacer"></span>
      <img src="assets/images/VEMO.png" alt="logo-vemo" />
    </mat-toolbar>
    <div class="container mt-5">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<div
  *ngIf="!loading && !absenceInfo"
  class="no-access-container d-flex justify-content-center align-items-center"
>
  <mat-card class="no-access-card">
    <mat-card-header class="no-access-header d-flex justify-content-center">
      <mat-card-title>Acceso no autorizado</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mt-3" align="center">
      <p>Enlace vencido, por favor comuníquese con el área de RRHH.</p>
    </mat-card-content>
  </mat-card>
</div>
